import "./App.css";
import { useEffect, useState } from "react";
import AuthenticatedApp from "./app/AuthenticatedApp";
import UnAuthenticatedApp from "./app/UnAuthenticatedApp";
import { useAuth } from "./context/authContext";
import { useNavigate } from "react-router-dom";
import { baseURL } from "./services/api";
import { requestNotificationPermission, setupForegroundMessageListener } from './services/notificationService';

import { urlBase64ToUint8Array } from "./send-sw-details";
import { useToast } from "@chakra-ui/react";
import { subscribeToPushNotifications } from './services/notificationService';

const WEB_PUSH_PUBLIC_KEY = "BKvNbHgS5v8Zte52gho8pFEOgS0gG65hl6rCYaJhEd7ewl27DNzRFNn-M69H8Gw9dyVKK_bu9Q9TAe16Onl0nkA";
// const WEB_PUSH_PUBLIC_KEY =
//   "BL_9glFng3bdStxfOmhe7M3jT06FzBTUZsjbF8dFvBEhBslgVxay_mYJtmp8t3GevVCBzXyz-RxbkaYLSa3ZYOk";

function App() {
  const navigate = useNavigate();
  const { isLoggedin, setIsLoggedin, userInfo } = useAuth();
  const { userId } = userInfo;
  const toast = useToast();
  const [isFirstInstall, setIsFirstInstall] = useState(false);

  useEffect(() => {
    // Check if this is the first time the app is being used
    const checkFirstTimeUser = () => {
      const hasUsedBefore = localStorage.getItem('app_previously_installed');
      if (!hasUsedBefore) {
        setIsFirstInstall(true);
        localStorage.setItem('app_previously_installed', 'true');
      }
    };

    checkFirstTimeUser();
  }, []);

  // useEffect(() => {
  //   if (!userId) return;
  
  //   async function subscribe() {
  //     try {
  //       // Subscribe to push notifications
  //       const result = await subscribeToPushNotifications(userId);
        
  //       // Only show the toast if the subscription was successful AND is new
  //       if (result.success && result.isNew) {
  //         toast({
  //           title: "Notifications enabled",
  //           description: "You will now receive notifications about estate updates",
  //           status: "success",
  //           duration: 5000,
  //           isClosable: true,
  //         });
          
  //         // Note: The backend will automatically send welcome notifications
  //         // if needed, so we don't need to trigger them from the frontend
  //       }
  //     } catch (error) {
  //       console.error('Error setting up notifications:', error);
  //       toast({
  //         title: "Notification setup failed",
  //         description: "Failed to set up notifications. You can try again in settings.",
  //         status: "error",
  //         duration: 5000,
  //         isClosable: true,
  //       });
  //     }
  //   }
    
  //   subscribe();
  // }, [userId, toast, isFirstInstall]);

  
  useEffect(() => {
    // Request notification permission and get token
    const initializeNotifications = async () => {
      const token = await requestNotificationPermission();
      
    };

    // Set up foreground message listener
    setupForegroundMessageListener();

    // Initialize notifications
    initializeNotifications();

  }, [userId]);
  
  // Rest of App.js remains the same
  useEffect(() => {
    const token = localStorage.getItem("11p221#");
    const old = localStorage.getItem("old");
    
    const checkTokenStatus = async () => {
      try {
        const response = await fetch(`${baseURL}/security/verify-token`, {
          method: "POST", // Assuming it's a POST request
          headers: { 
            "Content-Type": "application/json" 
          },
          body: JSON.stringify({ token: token }) // Sending the token in the request body
        });
    
        if (response.status === 401) {
          // Token is invalid, log out the user
          localStorage.removeItem("11p221#");
          setIsLoggedin(false);
          navigate("/login");
        }
      } catch (error) {
        console.error("Error checking token status:", error);
      }
    };
    
    if (!token) {
      setIsLoggedin(false);

      if (old) {
        return navigate("/login");
      }
    } else {
      setIsLoggedin(true);
      checkTokenStatus();
    }
  }, [setIsLoggedin]); // eslint-disable-line

  if (isLoggedin) {
    return <AuthenticatedApp />;
  }

  return <UnAuthenticatedApp />;
}

export default App;
